module.exports = __webpack_public_path__ + "static/media/kit_expansores.ec7cbeea.png";